import { Box } from "@mui/material";
import { useState } from "react";
import { FieldInput } from "../ra-lb-tools/components/unsourcedInputs";
import EventsList from "./events";
import CommandsList from "./commands";
import { Column } from "../ra-lb-tools/components/column";
import { LockerOpenRequestList } from "./lockerOpenRequest";
import { OpenLockerTokenList } from "./openLockerTokens";

export const ClientInfoSearch = () => {
  const [client_info, setClientInfo] = useState(null);
  const defaultProps = {
    perPage: 5,
    forceHeaders: true,
    sx: { marginTop: "20px" },
  };

  return (
    <Box className="ClientInfoSearch multi-sticky">
      <Box className="ListHeader">
        <Box
          className="ListTitleWrapper"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Column sx={{ flexWrap: "wrap" }}>
            <Box className="ListTitle">Client info search</Box>
            <Box className="ListSummary" sx={{ marginTop: "12px" }}>
              Search for client info across tables
            </Box>
          </Column>
        </Box>
      </Box>
      <Box className="SearchBoxWrapper sticky">
        <FieldInput
          className="SearchBox"
          name={"client_info"}
          value={client_info}
          setter={setClientInfo}
          placeholder="Search client info"
        />
      </Box>
      <Box
        className="TablesWrapper"
        sx={{
          "> *": { marginTop: "20px" },
          ".ListHeader": {
            position: "sticky",
            backgroundColor: "#eeeeee",
            top: "25px",
            zIndex: 99,
            padding: 0,
          },
          ".ListSummary": { display: "none" },
          ".RaDatagrid-headerCell": {
            top: "68px !important",
          },
        }}
      >
        <EventsList
          filter={client_info ? { eventData: { client_info } } : null}
          {...defaultProps}
        />
        <CommandsList
          filter={client_info ? { commandData: { client_info } } : null}
          {...defaultProps}
        />
        <LockerOpenRequestList
          filter={{ clientInfo: client_info }}
          {...defaultProps}
        />
        <OpenLockerTokenList
          filter={{ clientInfo: client_info }}
          {...defaultProps}
        />
      </Box>
    </Box>
  );
};
